export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];
export const listTitle = [
    {
        title: '4600 лидов на&nbsp;покупку квартир&nbsp;в&nbsp;новостройках: кейс застройщика СК10',
        subtitle:
            'Покажем на&nbsp;примере работы с&nbsp;крупнейшим застройщиком Ростовской области, как за&nbsp;счет ' +
            'HADI-циклов снизили стоимость лида на&nbsp;покупку недвижимости в&nbsp;5&nbsp;раз и&nbsp;привлекли 4&nbsp;600&nbsp;качественных лидов.',
        description: [
            {
                name: 'Отрасль',
                details: 'Недвижимость',
            },
            {
                name: 'Услуги',
                details: 'Performance-маркетинг',
            },
            {
                name: 'Сроки',
                details: 'январь – декабрь 2023',
            },
        ],
        company: 'СК10',
        companyLink: 'https://sk10.ru/',
        companyLinkName: 'sk10.ru',
        text:
            'Флагман жилищного строительства Ростова-на-Дону, на&nbsp;рынке строительства с&nbsp;1955&nbsp;года.' +
            ' Компания построила 17&nbsp;жилых комплексов, где проживают более 25&nbsp;тысяч семей. СК10 имеет высшую оценку по&nbsp;соблюдению декларируемого срока ввода жилья в&nbsp;эксплуатацию по&nbsp;данным Единого ресурса застройщиков.',
        info: `Победитель <a href="https://tagline.ru/awards/?utm_source=newsletter&utm_content=1&utm_medium=sms&utm_campaign=457.2-tagline-awards-2020-2021-april-2021" target="_blank" rel="noopener noreferrer nofollow">Tagline Awards 2023</a> в&nbsp;категории &laquo;Лучшая performance-кампания&raquo;`,
        icon: '/images/svg/ck10/tagline.svg',
    },
];
export const listStages = [
    {
        number: '1.',
        text:
            'Разработать комплексную стратегию, основанную на&nbsp;знании целевой аудитории, анализе конкурентов, ' +
            'репутации застройщика и&nbsp;понимания рынка.',
    },
    {
        number: '2.',
        text:
            'Определить гипотезы первого приоритета и&nbsp;посчитать по&nbsp;ним цену клика, количество показов, ' +
            'CTR, CR, процент качества лидов.',
    },
    {
        number: '3.',
        text: 'Запланировать количество кликов, бюджеты и&nbsp;стоимость лидов по&nbsp;каждой рекламной кампании.',
    },
];
export const listSolutions = [
    {
        description:
            'В&nbsp;недвижимости базовыми каналами для лидогенерация уже традиционно остаются контекстная' +
            ' и&nbsp;медийная реклама. Но&nbsp;в&nbsp;этих традиционных каналах ' +
            'необходимо искать и&nbsp;тестировать новые форматы.',
    },
    {
        description: 'Начали работу со&nbsp;стандартных для данного сегмента рынка гипотез:',
    },
];

export const listResults = [
    {
        title: 'в 3 – 4 раза',
        description: 'CPL в&nbsp;старых&nbsp;РК дороже нашего прогноза',
    },
    {
        title: '25%',
        description: 'рекламных кампаний не&nbsp;приносили лиды',
    },
];

export const listSolutionsMedia = [
    {
        description: 'Брендовые РК&nbsp;на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'РК&nbsp;по&nbsp;конкурентам на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'РК&nbsp;с&nbsp;геозависимыми запросами на&nbsp;Поиске и&nbsp;в&nbsp;РСЯ',
    },
    {
        description: 'Мастер кампании с&nbsp;автотаргетингом',
    },
];

export const listSolutionsMediaParagraf = [
    {
        description:
            'Также протестировали различные Look-alike аудитории, которые подобрали на&nbsp;основе клиентской ' +
            'базы застройщика.',
    },
    {
        description:
            'Результаты первых двух месяцев показали, что цена лида стала в&nbsp;2&nbsp;раза ниже от&nbsp;прошлых ' +
            'запусков. Хорошо себя показала стратегия на&nbsp;оптимизацию конверсий с&nbsp;использованием ' +
            'автотаргетинга. Но&nbsp;объем лидов был недостаточным.',
    },
    {
        description:
            'Для достижения запланированных амбициозных результатов решили изменить стратегию, чтобы увеличить ' +
            'количество лидов и&nbsp;сделать их&nbsp;дешевле.',
    },
];

export const listSolutionsPages = [
    {
        description:
            'Поисковые РК&nbsp;и&nbsp;РСЯ кампании с&nbsp;прямой и&nbsp;брендовой семантикой',
    },
    {
        description:
            'Поисковые РК&nbsp;с&nbsp;интересами, сегментами и&nbsp;семантикой, связанной с&nbsp;инвестициями',
    },
    {
        description: 'РСЯ кампании на&nbsp;премиум сегменты и&nbsp;интересы',
    },
];

export const listSolutionsParagraf = [
    {
        description:
            'Так как у&nbsp;сайта очень низкий процент конверсии, решили перевести&nbsp;РК на&nbsp;квиз. Это ' +
            'сразу&nbsp;дало результаты. Например, для премиального жилого комплекса использовали ' +
            'квиз из&nbsp;5&nbsp;блоков с&nbsp;акцентами на&nbsp;основные преимущества данного&nbsp;ЖК.',
    },
    {
        description: 'Мы&nbsp;тестировали различные гипотезы:',
    },
];

export const listSolutionsAnaliz = [
    {
        description:
            'Внедрили систему еженедельных аудитов РК. По&nbsp;результатам анализов принимались решения ' +
            'о&nbsp;корректировках&nbsp;РК, сменах стратегии, корректировках целей, ставок.',
    },
    {
        description:
            'Благодаря структурной работе PPC-команды и&nbsp;качественному менеджменту проекта ' +
            'за&nbsp;12&nbsp;месяцев нам удалось протестировать более 3000 гипотез по&nbsp;болям и&nbsp;мотивам ' +
            'аудитории, гео, различных УТП, вовремя осуществлять корректировки креативов, текстов&nbsp;и&nbsp;настроек' +
            ' на&nbsp;основе анализа результатов, найти максимально эффективные решения, в&nbsp;принятии которых ' +
            'мы&nbsp;ориентировались на&nbsp;глубокую сквозную аналитику.',
    },
];

export const listSolutionsDifficulties = [
    {
        number: '1.',
        text: 'Большая внутренняя команда.',
    },
    {
        number: '2.',
        text: 'Много новых запусков рекламных кампаний.',
    },
    {
        number: '3.',
        text: 'Частая смена креативов, офферов по&nbsp;всем объектам строительства.',
    },
    {
        number: '4.',
        text: 'Большой объем аналитики и&nbsp;трудозатратные отчеты.',
    },
];

export const listPageResults = [
    {
        title: '3 000+',
        description: 'протестировали гипотез',
    },
    {
        title: '200 ',
        description: 'рекламных компаний в&nbsp;Я.&nbsp;Сервисах',
    },
    {
        title: '320 млн',
        description: 'показов',
    },
    {
        title: '847 000',
        description: 'кликов',
    },
    {
        title: '4 600+',
        description: 'лидов',
    },
    {
        title: '3,58%',
        description: 'CR',
    },
    {
        title: '<10 000 руб.',
        description: 'CPL',
    },
    {
        title: '3%',
        description: 'доля рекламных расходов',
    },
];
